import clsx from 'clsx';
import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import {
  NODE_PARAGRAPH,
  render,
  MARK_LINK,
} from 'storyblok-rich-text-react-renderer';
import LinkResolver from '../../helpers/link-resolver';
import Container from '../Container';

export default function Richtext({ blok }) {
  const splitText = '';
  const styles = clsx(
    blok.variant === 'default' ? 'text-black' : 'text-white',
    blok.two_columns ? 'xl:columns-2' : '',
    'latori-color-green-dark pb-6 job-detail',
    splitText ? 'xl:columns-2' : '',
  );

  const glowVariant = blok.variant === 'latori-pink-mono-line'
    ? 'text-latori-pink text-center text-3xl font-monospace italic mt-12 glow'
    : '';

  const textFontSize = blok.font_size ? `text-[${blok.font_size}px]` : '';

  const paragraphStyle = clsx(
    'first-of-type:mt-0 last-of-type:mb-0 m-auto my-4',
    textFontSize,
    glowVariant,
  );

  const Wrapper = blok.use_container ? Container : React.Fragment;

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <Wrapper>
        {render(blok.content, {
          markResolvers: {
            [MARK_LINK]: LinkResolver,
          },
          nodeResolvers: {
          // eslint-disable-next-line react/no-unstable-nested-components
            [NODE_PARAGRAPH]: (children) => (
              <p className={paragraphStyle} style={{ fontSize: `${blok.font_size}px` }}>{children}</p>
            ),
          },
        })}
      </Wrapper>
    </div>
  );
}
